import React from 'react';
import { Modal } from 'antd';
import PostEditor from './PostEditor';

const PostEditorDialog = ({ open, post, busy = false, onBusyChange, onCancel, onSaved }) => {
  const close = () => { if (!busy) onCancel(); };
  return <Modal title="编辑帖子" className="post-editor-modal" open={open} centered footer={null} destroyOnHidden width={960}
    classNames={{ container: 'post-editor-modal-container', header: 'post-editor-modal-header', body: 'post-editor-modal-body' }}
    closable={!busy} mask={{ closable: !busy }} keyboard={!busy} onCancel={close}>
    {open && <PostEditor key={post.id} post={post} onBusyChange={onBusyChange} onCancel={close} onSaved={onSaved} />}
  </Modal>;
};

export default PostEditorDialog;
